import type { RouteThunk } from 'redux-first-router';
import { NOT_FOUND, redirect } from 'redux-first-router';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { userDataInitializedSel } from '@modules/user/duck/selectors';

import { RosterV2Page } from './components';
import { ROUTE_ROSTER_V2 } from './duck/actions';
import { hasRosterV2PermissionSel } from './duck/selectors';

/**
 * Basic route check for feature flag but most wrapping logic lives in RosterV2Container
 */
const rosterV2Thunk: RouteThunk = (dispatch, getState) => {
  const state = getState();
  if (!userDataInitializedSel(state)) return;

  const enabled = featureFlags.getFlag('SBL_6888_ROSTER_V2');
  const allowed = hasRosterV2PermissionSel(state);
  if (!enabled || !allowed) {
    dispatch(redirect({ type: NOT_FOUND, payload: { code: 403 } }));
  }
};

const routes = {
  [ROUTE_ROSTER_V2]: {
    path: '/roster-v2/:organizationGuid',
    Component: RosterV2Page,
    titleId: 'page.rosterV2',
    thunk: rosterV2Thunk,
  },
};

export default routes;
